export const item = Symbol("item");

export default {
    item,
};
